import styled from 'styled-components';

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: center;
  min-height: 2em;
  font-family: ${props => props.theme.fontSets.narrowRegular};
  border-bottom: 1px solid ${props => props.theme.colors.lightGray};;
  margin-top: 3px;
  padding-bottom:3px;
  a{
     pointer-events: ${props => (props.isGazzanet ? 'none !important' : 'initial')};
     cursor: ${props => (props.isGazzanet ? 'default !important' : 'initial')};
  }
`;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/TableRow/styles.js